import React from "react";
import moment from "moment";
import { Range, fromJS } from "immutable";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

const dateFormat = "DD/MM/YYYY";

const CustomizedAxisTick = ({ x, y, stroke, payload }) =>
  <g transform={`translate(${x},${y})`}>
    <text
      x={0}
      y={0}
      dy={16}
      textAnchor="end"
      fill="#666"
      transform="rotate(-35)"
    >
      {payload.value}
    </text>
  </g>;

export const OrdersByDayBarChart = ({ orders, date }) => {
  if (!orders || !date) return null;
  const firstHour = 0;
  const hoursOfADay = day =>
    Range(firstHour, 24, 1)
      .toMap()
      .map(i =>
        fromJS({
          text: `${day.format("DD/MM")} ${i}h`,
          value: 0,
          date: moment(day).add(firstHour + i, "hours").format()
        })
      )
      .mapKeys(i => `${moment(day).add(firstHour + i, "hours").format()}`)
      .toOrderedMap();

  const add = (a, b) => a + b;

  const existingTotalsByHour = orders
    .map(order => ({
      value: order
        .get("orderLines")
        .map(line => line.get("quantity") * line.get("unitPrice"))
        .reduce(add),
      date: order.get("createdAt")
    }))
    .groupBy(order => moment(order.date).startOf("hour").format())
    .map(orderArray => orderArray.map(order => order.value).reduce(add))
    .map((item, key) =>
      fromJS({
        text: moment(key).format("DD/MM HH[h]"),
        value: item,
        date: key
      })
    );

  const totalsByHour = hoursOfADay(moment(date, dateFormat))
    .map(
      (h, k) => (existingTotalsByHour.get(k) ? existingTotalsByHour.get(k) : h)
    )
    .toList()
    .sort(
      (a, b) => (moment(a.get("date")).isBefore(moment(b.get("date"))) ? -1 : 1)
    )
    .toJS();
  const datum = Object.values(totalsByHour);

  return (
    <ResponsiveContainer width="90%" minHeight={250}>
      <ComposedChart
        data={datum}
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
      >
        <XAxis dataKey="text" height={70} tick={<CustomizedAxisTick />} />
        <YAxis width={70} />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Legend />
        <Bar
          dataKey="value"
          barSize={20}
          fill="#413ea0"
          name="Ingresos"
          legendType="none"
          unit="€"
        />
        <Line
          type="monotone"
          dataKey="value"
          stroke="#8884d8"
          name="Ingresos"
          unit="€"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default OrdersByDayBarChart;



// WEBPACK FOOTER //
// ./src/components/presentational/OrdersByDayBarChart.js